<template>
  <div>
    <criterion-category-index
      :formSearch="formSearch"
      :enableExport="false"
      :columns="columns"
      :title="$t('menu.criterion_category_list')"
      :serviceName="serviceName"
    />
  </div>
</template>

<script>
import CriterionCategoryIndex from "./CriterionCategoryIndex";

export default {
  name: "Index",
  data() {
    return {
      serviceName: "criterion-categories",
      formSearch: [
        {
          label: this.$t("criterion_category.name"),
          name: "name__~",
          value: "",
          type: "input"
        }
      ],
      columns: {
        id: this.$t("criterion_category.id"),
        name: this.$t("criterion_category.name"),
        description: this.$t("criterion_category.description"),
        created_at: this.$t("criterion_category.created_at"),
        updated_at: this.$t("criterion_category.updated_at")
      }
    };
  },
  components: { CriterionCategoryIndex },
  methods: {},
  mounted() {}
};
</script>
